import { render } from "./App.vue?vue&type=template&id=5a6ef2fa"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=5a6ef2fa&lang=less"

import exportComponent from "C:\\Users\\dslx464\\Desktop\\workspace\\tertiary-page\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__